import { Flex, Text } from '@chakra-ui/react';
import { faBoxArchive } from '@fortawesome/pro-regular-svg-icons';
import { ButtonText } from '@morressier/alembic';
import { useState } from 'react';
import { IconBadge } from 'src/components/IconBadge';
import { WithdrawalContextModal } from 'src/components/Submission/modals/WithdrawalContextModal';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';

export const EditorialAuthorWithdrawalRequested = () => {
  const [showModal, setShowModal] = useState(false);
  const { withdrawal } = useSubmissionData();

  return withdrawal?.requestedByAuthor ? (
    <>
      <Flex
        width="100%"
        gap={3}
        alignItems="start"
        borderColor="neutralPrimaryBorder"
        borderBottomWidth={1}
        borderStyle="solid"
        paddingY={2}
      >
        <IconBadge icon={faBoxArchive} variant="attention" />
        <Flex flexDirection="column" flex={1}>
          <Text textStyle="headingItem">Withdrawal Requested by Author</Text>
          <Text textStyle="textContext">
            Review the Author’s request and decide on their Submission.
          </Text>
        </Flex>

        <ButtonText marginLeft="auto" onClick={() => setShowModal(true)}>
          View Request
        </ButtonText>
      </Flex>
      {showModal && (
        <WithdrawalContextModal
          role="editorial"
          onClose={() => setShowModal(false)}
          data={withdrawal}
          type="AuthorSubmissionWithdrawalRequested"
        />
      )}
    </>
  ) : null;
};
